var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentComponent,{tag:"component",attrs:{"editMode":this.editMode},on:{"load":_vm.Load,"getInfoPatient":_vm.InfoPatient,"getVisibleMenu":_vm.emitToGrandparent}})}
var staticRenderFns = []

export { render, staticRenderFns }